import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduzir título da notificação',
    },
    body: {
      label: 'Corpo da mensagem',
      placeholder: 'Introduza a sua mensagem',
    },
    promo_code: {
      label: 'Código promocional',
      placeholder: 'Selecionar código promocional',
    },
    offers: {
      label: 'Ofertas',
      placeholder: 'Selecionar oferta',
    },
    campaign_type: {
      label: 'Tipo de campanha',
      placeholder: 'Selecionar tipo de campanha',
    },
    tone: {
      label: 'Tom de voz',
      placeholder: 'Selecionar um tom',
    },
  },
  attachment: {
    heading: 'O que deve esta campanha promover?',
    offer: {
      title: 'Oferta',
      description: 'Escolha das suas ofertas ativas.',
    },
    promo_code: {
      title: 'Código promocional',
      description: 'Escolha dos seus códigos promocionais ativos.',
    },
  },
  buttons: {
    generate: 'Gerar',
    improve: 'Melhorar com IA',
    undo: 'Desfazer ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Simpático 🙂',
    [ToneTypes.Elegant]: 'Elegante ✨',
    [ToneTypes.Playful]: 'Divertido 🎉',
    [ToneTypes.Professional]: 'Profissional 👨‍💼',
    [ToneTypes.Informative]: 'Informativo 📊',
    [ToneTypes.Persuasive]: 'Persuasivo 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promocional 🚀',
    [CampaignTypes.Informational]: 'Informacional ℹ️',
  },
  no_promo_codes: {
    title: 'Sem códigos promocionais elegíveis',
    description: 'Crie um novo código promocional.',
    create_promo_code: 'Criar código promocional',
  },
  no_offers: {
    title: 'Sem ofertas ativas',
    description: 'Crie uma nova oferta.',
    create_offer: 'Criar oferta',
  },
  feedback: {
    success: 'Gerado com sucesso',
    error: 'Falha ao gerar',
  },
};
